export enum FulfillmentMethod {
	BBE = 'bopisBoplExclusive',
	MIXED = 'mixed',
	SDDE = 'sameDayDeliveryExclusive',
	STH = 'shipToHome'
}
